import { ProgressModelBase, ProgressAction } from './progress-model';
import { UUID } from '../utils/helpers';

export class ProgressModelImpl extends ProgressModelBase {

    actionStarted(target: string, metadata?: {[index: string]: any}) {
        const action: ProgressAction = {
            id: UUID(),
            target: target,
            state: 'pending',
            startedAt: new Date().getTime(),
            completedAt: 0,
            metadata: metadata
        };

        const targetActions = this._targetToPendingActions.get(target) || [];
        targetActions.push(action);
        this._targetToPendingActions.set(target, targetActions);

        this.dispatchEvent(new CustomEvent(`target-actions-changed`, {detail: {target: target, pendingActions: targetActions, completedActions: this._targetToCompletedActions.get(target) || []}}));

        return action;
    }

    actionCompleted(action: ProgressAction) {
        action.state = 'completed';
        action.completedAt = new Date().getTime();

        const targetPendingActions = (this._targetToPendingActions.get(action.target) || []).filter(x => x.id !== action.id);
        this._targetToPendingActions.set(action.target, targetPendingActions);

        const targetCompletedActions = this._targetToCompletedActions.get(action.target) || [];
        targetCompletedActions.push(action);
        this._targetToCompletedActions.set(action.target, targetCompletedActions);

        this.dispatchEvent(new CustomEvent(`target-actions-changed`, {detail: {target: action.target, pendingActions: targetPendingActions, completedActions: targetCompletedActions}}));
        this.dispatchEvent(new CustomEvent(`action-completed`, {detail: {action}}));
    }

    getTargetActions(target: string) {
        return {
            pending: this._targetToPendingActions.get(target) || [],
            completed: this._targetToCompletedActions.get(target) || []
        };
    }

    private _targetToPendingActions: Map<string, ProgressAction[]> = new Map();
    private _targetToCompletedActions: Map<string, ProgressAction[]> = new Map();
}
